import { useState } from "react";
import { Reveal, Overline } from "@/components/site/Reveal";
import { IMAGES } from "@/lib/site";
import { useLang } from "@/context/LanguageContext";

export const Video = () => {
  const { t } = useLang();
  const [videoError, setVideoError] = useState(false);

  return (
    <section id="video" data-testid="video-section" className="relative bg-white py-24 md:py-32">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex items-center gap-3 mb-4">
            <span className="w-8 gold-rule" />
            <Overline>{t("video.overline")}</Overline>
          </div>
          <h2 className="font-display text-3xl md:text-5xl tracking-tight text-[#0A1128]">{t("video.title")}</h2>
          <p className="mt-3 text-[#4B5563] md:text-lg max-w-2xl">{t("video.sub")}</p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-8 relative overflow-hidden bg-[#0A1128] aspect-video ring-1 ring-inset ring-[#D4AF37]/30 shadow-lg">
            {videoError ? (
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
                <span className="font-display text-white text-2xl">{t("video.title")}</span>
                <span className="mt-2 text-sm uppercase tracking-[0.2em] text-[#D4AF37]">{t("video.soon")}</span>
              </div>
            ) : (
              <video data-testid="fbla-video-player" controls playsInline preload="metadata"
                poster={IMAGES.fbla4} onError={() => setVideoError(true)} className="w-full h-full object-cover">
                <source src="https://fohamu.com/assets/fbla-awards-6044870afc994d9ea7ed0b90d3538f2f2c05fa5a9a5ba16da2dc044192e697e0.webm" type="video/webm" />
                <source src="/fbla-commercial.mp4" type="video/mp4" />
              </video>
            )}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-5 flex items-start gap-4" data-testid="fbla-video-caption">
            <span className="hidden md:block w-10 gold-rule mt-3 shrink-0" />
            <div>
              <p className="font-display text-lg md:text-xl text-[#0A1128]">{t("video.captionTitle")}</p>
              <p className="mt-1 text-[#4B5563] leading-relaxed max-w-3xl">{t("video.captionBody")}</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
